import template from './branch_funding_source_holiday.html';
import controller from './branch_funding_source_holiday.controller';
import './branch_funding_source_holiday.scss';

let branchFundingSourceHolidayComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default branchFundingSourceHolidayComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/branch_funding_source_holiday.component.js